<template>
  <!-- 用户编辑 -->
  <div class="page-container" id="userManagementContainer">
    <el-form
      :model="sysUser"
      :rules="userEditFormRules"
      ref="ruleFormRef"
      class="form-panel"
      label-position="top"
      :validateOnRuleChange="false"
    >
      <el-col :span="24">
        <el-row class="content-panel">
          <el-row>
            <el-col style="margin-bottom: 8px">
              <el-button type="primary" size="small" plain @click="preserve"
                >保存</el-button
              >
              <el-button
                type="danger"
                size="small"
                plain
                @click="handleResetPwd"
                >重置密码</el-button
              >
              <el-button type="primary" size="small" plain @click="handleEnable"
                >生效</el-button
              >
              <el-button type="danger" size="small" plain @click="handleDisable"
                >失效</el-button
              >
            </el-col>
          </el-row>
          <el-row :gutter="22">
            <el-col :span="6">
              <el-form-item label="登录账号" prop="userName">
                <el-input size="mini" v-model="sysUser.userName" name="userName" :disabled="sysUser.sysUserId>0" case="upper"  @blur="onChangeUserName" id="userName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="中文名称" prop="userNameCn">
                <el-input size="mini" v-model="sysUser.userNameCn" case="upper"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="用户类型" prop="userTypeCn">
                <el-select
                  multiple
                  class="length_input"
                  size="mini"
                  v-model="sysUser.userTypeCn"
                  @change="changeType"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in userTypelist"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="性别" prop="sex">
                <el-select
                  class="length_input"
                  size="mini"
                  v-model="sysUser.sex"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in sex"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="22">
            <el-col :span="6">
              <el-form-item label="英文名称" prop="userNameEn">
                <el-input size="mini" v-model="sysUser.userNameEn" case="upper"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="身份证号码" prop="identityCardNo">
                <el-input
                  size="mini"
                  v-model="sysUser.identityCardNo" case="upper"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item label="电子邮箱/密码" prop="email">
                    <el-input size="mini" v-model="sysUser.email" case="upper"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="">
                    <label slot="label" class="label_no">&nbsp;</label>
                    <el-input
                      size="mini"
                      type="password"
                      v-model="sysUser.emailPassword"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="6">
              <el-form-item label="邮箱别名" prop="emailAlias">
                <el-input size="mini" v-model="sysUser.emailAlias" case="upper"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="22">
            <el-col :span="6">
              <el-form-item label="手机号码" prop="mobilePhone">
                <el-input size="mini" v-model="sysUser.mobilePhone" case="upper"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="办公电话" prop="tel">
                <el-input size="mini" v-model="sysUser.tel" case="upper"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="传真" prop="fax">
                <el-input size="mini" v-model="sysUser.fax" case="upper"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="微信号" prop="wechat">
                <el-input size="mini" v-model="sysUser.wechat" case="upper"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="22">
            <el-col :span="6">
              <el-form-item label="QQ号码" prop="qq">
                <el-input size="mini" v-model="sysUser.qq" case="upper"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="备注" prop="remark">
                <el-input size="mini" v-model="sysUser.remark"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="在职状态" prop="inserviceStatus">
                <el-select
                  class="length_input"
                  size="mini"
                  v-model="sysUser.inserviceStatus"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in inserviceStatus"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="数据权限范围" prop="dataAuthorityNames">
                <!-- <el-input size="mini" v-model="sysUser.dataAuthorityId"></el-input> -->
                <el-associate
                  style="width: 100%"
                  :columns="associate_columns_sysDataAuthorityRangeQuery"
                  :query-method="
                    associate_queryMethod_sysDataAuthorityRangeQuery
                  "
                  class="input_length"
                  multiple
                  clearable
                  :query-length="0"
                  :default-first-option="true"
                  label-prop="dataAuthorityName"
                  value-prop="dataAuthorityName"
                  placeholder=""
                  v-model="sysUser.dataAuthorityNames"
                  size="mini" case="upper"
                  @change="changeDataAuthorityIds"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="22">
            <el-col :span="6">
              <el-form-item label="有效标志" prop="isActive">
                <el-select
                  class="length_input"
                  size="mini"
                  v-model="sysUser.isActive"
                  placeholder="请选择"
                  disabled
                >
                  <el-option
                    v-for="item in isActiveList"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="生效时间" prop="activeStartTime">
                <el-date-picker
                  v-model="sysUser.activeStartTime"
                  align="right"
                  type="date"
                  size="mini"
                  style="width: 100%"
                  placeholder="选择日期"
                  :picker-options="pickerOptions"
                  disabled
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="失效时间">
                <el-date-picker
                  v-model="sysUser.activeEndTime"
                  align="right"
                  type="date"
                  size="mini"
                  style="width: 100%"
                  placeholder="选择日期"
                  :picker-options="pickerOptions"
                  disabled
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="用户来源" prop="userSource">
                <el-select
                  class="length_input"
                  size="mini"
                  v-model="sysUser.userSource"
                  placeholder="请选择"
                  disabled
                >
                  <el-option
                    v-for="item in userSource"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="22">
            <el-col :span="6">
              <el-form-item label="入职时间" prop="entryDate">
                <el-date-picker
                  v-model="sysUser.entryDate"
                  style="width: 100%"
                  align="right"
                  type="date"
                  size="mini"
                  placeholder="选择日期"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <el-row class="title-panel panel-container">
          <el-col :span="3">
            <span
              @click="changePanel"
              data-panel="1"
              :class="[
                'panel-cursor',
                currentPanel === '1' ? 'panel-cursor-current' : '',
              ]"
              >业务组织</span
            >
          </el-col>
          <el-col :span="3">
            <span
              @click="changePanel"
              data-panel="2"
              :class="[
                'panel-cursor',
                currentPanel === '2' ? 'panel-cursor-current' : '',
              ]"
              >用户角色</span
            >
          </el-col>
        </el-row>
        <el-row v-show="currentPanel === '1'">
            <el-row :gutter="22">
              <el-col :span="6">
                <el-form-item label="默认组织" prop="defaultOfficeName">
                  <el-associate
                    hot-editor
                    style="width: 100%"
                    :columns="associate_columns_OfficeName"
                    :query-method="associate_queryMethod_OfficeName"
                    class="input_length"
                    clearable
                    :query-length="0"
                    :default-first-option="true"
                    label-prop="officeName"
                    value-prop="officeName"
                    placeholder=""
                    size="mini"
                    v-model="sysUser.defaultOfficeName"
                    @change="changeDefaultOffice"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="默认结算公司" prop="defaultCorpName">
                  <el-associate
                    hot-editor
                    style="width: 100%"
                    :columns="associate_columns_sysCorp"
                    :query-method="associate_queryMethod_sysCorp"
                    class="input_length"
                    clearable
                    :query-length="0"
                    :default-first-option="true"
                    label-prop="corpNameCn"
                    value-prop="corpNameCn"
                    placeholder=""
                    size="mini"
                    v-model="sysUser.defaultCorpName"
                    @change="changedefaultCorp"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-tree
                :data="treeData"
                :props="defaultProps"
                @node-click="handleNodeClick"
                show-checkbox
                :check-strictly="true"
                @check="changeOfficeTree"
              >
              </el-tree>
            </el-row>
        </el-row>
        <el-row v-show="currentPanel === '2'">
            <el-row>
              <el-button type="primary" size="mini" @click="addUesr">
                添加角色
              </el-button>
              <el-button type="danger" size="mini" @click="deleteUser">
                移除角色
              </el-button>
            </el-row>
            <el-row class="panel-top">
              <hot-table
                ref="userManagementTableRef"
                :data-source="sysUser.sysUserRoles"
                :settings="userRolesSettings"
                @rowClick="currentRoleNameSysUserRoleRowClick"
                :rules="userManagementTableRule"
              >
                <hot-column
                  width="30"
                  :has-tip="true"
                  data="roleName"
                  title="<label style='color:red'>*</label>角色名称"
                >
                  <el-associate-editor
                    hot-editor
                    style="width: 100%"
                    :columns="associate_columns_roleNameSysUserRole"
                    :query-method="associate_queryMethod_roleNameSysUserRole"
                    class="input_length"
                    clearable
                    :query-length="0"
                    :default-first-option="true"
                    label-prop="roleName"
                    value-prop="roleName"
                    placeholder=""
                    size="mini"
                    @change="changeRoleNameSysUserRole"
                  />
                </hot-column>
                <hot-column
                  :has-tip="true"
                  data="creatorName"
                  title="创建人"
                  width="50"
                >
                  <el-input-number-editor
                    :controls="false"
                    :precision="0"
                    :min="0"
                    case="upper"
                    hot-editor
                    name="creatorName"
                    disabled
                  />
                </hot-column>
                <hot-column
                  width="50"
                  :has-tip="true"
                  data="createTime"
                  title="创建时间"
                >
                  <el-input-number-editor
                    :controls="false"
                    :precision="0"
                    :min="0"
                    case="upper"
                    hot-editor
                    name="createTime"
                    disabled
                  />
                </hot-column>
                <hot-column
                  width="50"
                  :has-tip="true"
                  data="lastModifierName"
                  title="最后修改人"
                >
                  <el-input-number-editor
                    :controls="false"
                    :precision="0"
                    :min="0"
                    case="upper"
                    hot-editor
                    name="lastModifierName"
                    disabled
                  />
                </hot-column>
                <hot-column
                  width="50"
                  :has-tip="true"
                  data="lastModifyTime"
                  title="最后修改时间"
                >
                  <el-input-number-editor
                    :controls="false"
                    :precision="0"
                    :min="0"
                    case="upper"
                    hot-editor
                    name="lastModifyTime"
                    disabled
                  />
                </hot-column>
              </hot-table>
            </el-row>
        </el-row>
        <!-- 表格-start -->
        <el-row style="margin-top: 15px"> </el-row>
      </el-col>
    </el-form>
  </div>
</template>

<script>
import { queryDictRows } from "@/api/commonService";
import { getSysUser } from "@/api/system";
import router from "@/router";
import { Collapse } from "element-ui";
import { getUserOfficeTree } from "@/api/system";
import { array } from "jszip/lib/support";
import { getTreeData } from '@/utils/common'
import {
  update,
  querySysRole,
  querySysUserRole,
  deletesSysUserRole,
  sysDataAuthorityRangeQuery,
  save,
  resetPassword,
  activeSysUser,
  sysOffice,
  settleByOfficeIds,
  checkSysUserName
} from "@/api/system";
import { userManagementRule, userInRule } from "@/rules/userEdit";
export default {
  data() {
    return {
      filterOfficeIds: '',
      currentPanel: "1",
      type: "save",
      associate_columns_sysDataAuthorityRangeQuery: [
        {
          title: "权限名称",
          field: "dataAuthorityName",
        },
      ],
      isActiveList: [],
      userManagementTableRule: {},
      currentRoleNameSysUserRole: null,
      associate_columns_roleNameSysUserRole: [
        {
          title: "角色代码",
          field: "roleCode",
        },
        {
          title: "角色名称",
          field: "roleName",
        },
      ],
      associate_columns_OfficeName: [
        {
             title: "组织名称",
          field: "officeName",
        },
        {
             title: "组织代码",
          field: "officeCode",
        },
        {
             title: "业务中心",
          field: "affiliatedDeptOfficeName",
        },
      ],
      associate_columns_sysCorp: [
{
             title: "公司代码",
          field: "corpCode",
        },{
             title: "公司简称",
          field: "corpName",
        },{
             title: "中文全称",
          field: "corpNameCn",
        },
        {
             title: "上级组织",
          field: "parentOfficeName",
        },
      ],
      resizeObserver: null,
      resizeObserverSec: null,
      activeName: "1",
      userEditForm: {},
      sysUser: {
        userName: '',
        userNameCn: "",
        sex: "",
        userNameEn: "",
        identityCardNo: "",
        email: "",
        emailPassword: "",
        emailAlias: "",
        mobilePhone: "",
        tel: "",
        wechat: "",
        qq: "",
        remark: "",
        sysUserRoles: [],
        isActive: "1",
        userSource: "1",
        activeStartTime: new Date(),
        rowStatus: 4,
        userTypeCn: [],
        isPasswordModify: "N",
        isExternal: 0
      },
      // 分页
      pageConfig: {
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
        pageSize: 10,
        pagerCount: 10,
        currentPage: 1,
        pageSizes: [10, 20, 50, 100],
      },
      // currentPage 改变时会触发
      // handleCurrentChange(val) {
      // 	console.log(`当前页: ${val}`)
      // 	this.pageConfig.currentPage = val
      // },
      // 校验
      userEditFormRules: {},
      orgForm: {},
      orgFormRules: {
        defaultOfficeName:[
          { required: true, message: "默认组织不能为空",  trigger: ['blur', 'change']  }
        ],
        defaultCorpName:[
          { required: true, message: "默认结算公司不能为空",  trigger: ['blur', 'change']  }
        ]
      },
      // 表格数据
      userManagementTableDataSource: [],
      // 表格设置
      userManagementTableSettings: {
        height: 360,
        stretchH: "all", // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig,
      },
      userTypelist: [],
      inserviceStatus: [],
      sex: [],
      userSource: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      userRolesSettings: {
        height: 170,
        autoColumnSize: true,
        stretchH: "none",
        ...this.$systemConfig.tableConfig,
      },
      externalCodeRequests: [],
      externalCodeSettings: {
        height: 170,
        autoColumnSize: true,
        stretchH: "none",
        ...this.$systemConfig.tableConfig,
      },
      ExternalCode: {},
      ExternalCodeRules: {
        use_code: [{ required: true, message: "" }],
      },
      treeData: [],
      defaultProps: {
        label: "name",
        children: "children",
        // isLeaf: 'leaf'
      },
    };
  },
  async created() {

  },
  async mounted() {
    let self = this;
    console.log(self.$refs);
    self.userManagementTableRule = userManagementRule;
    self.getSelectList();
    if (self.$route.params && self.$route.params.sysUserId) {
      self.type = "update";
      self.getData(self.$route.params.sysUserId);
    }
        let obj={
            sysUserId: 6889012464362516480,
        }
       getUserOfficeTree(obj).then(res => {
            if(res.success) {
              let parentArr = getTreeData(res.result);
              this.treeData = parentArr;
            }
       })
    this.userEditFormRules = userInRule;
  },
  methods: {
    async getData(id) {
      let self = this;
      let sysuser = {
        sysUserId: id,
        cascade: false,
      };
      await getSysUser(sysuser).then((res) => {
        self.sysUser = res.sysUser;
        res.sysUser.isActive = res.sysUser.isActive.toString();
        self.sysUser.userTypeCn = self.sysUser.userType.split(",");
        self.sysUser.dataAuthorityIds = self.sysUser.dataAuthorityId.split(";");
        self.sysUser.dataAuthorityNames = self.sysUser.dataAuthorityName.split(";");
      });
      await self.querySysUserRole(id);
    },
    changedefaultCorp(value, selectedRows) {
       this.sysUser.defaultCorpCode = selectedRows.sysCorpId
       this.sysUser.defaultCorpName = selectedRows.corpNameCn
    },
    changeDefaultOffice(value, selectedRows) {
      this.sysUser.deptOfficeNameValue = selectedRows.affiliatedDeptOfficeName
      this.sysUser.defaultOfficeName = selectedRows.officeName;
      this.sysUser.defaultOfficeId = selectedRows.defaultOfficeId
      this.sysUser.defaultOffice = selectedRows.sysOfficeId
    },
    changeDataAuthorityIds(value, selectedRows){
      let self = this;
      let dataAuthorityId = [];
      selectedRows.forEach(item => {
        dataAuthorityId.push(item.sysDataAuthorityId);
      })
      self.sysUser.dataAuthorityId = dataAuthorityId.join(";");
      let dataAuthorityName = [];
      selectedRows.forEach(item => {
        dataAuthorityName.push(item.dataAuthorityName);
      })
      // self.sysUser.dataAuthorityName = dataAuthorityName
      self.sysUser.dataAuthorityName = dataAuthorityName.join(";");
    },
    changeType(event, item) {
      console.log(event);
      this.$forceUpdate();
    },
    changePanel(e) {
        let self = this
      console.log(e);
      this.currentPanel = e.target.dataset.panel;
      if(this.currentPanel === '2') {
            let containerWidth =
        document.getElementById("userManagementContainer").clientWidth - 21.22;
      setTimeout(() => {
        self.$refs.userManagementTableRef.resizeTo(containerWidth);
        self.$refs.userManagementTableRef.render()
      });
      }
    },
        onChangeUserName(value) {

          var userName=value.target.value;
          let self = this;
          let data = {
            userName:userName
          }
           checkSysUserName(data).then((res) => {
               if (res.success) {
                  var u=document.getElementById("userName");
                    if(res.result){
                     u.style.borderColor="#F56C6C";
                     self.$coreMethods.message('error', '该登录账号已存在！')
                    }else{
                      u.style.borderColor="#DCDFE6";
                     }
                }
           });

        },
    handleResetPwd() {
      let self = this;
      if (self.type === "save")
        return self.$coreMethods.message("warning", "请先保存用户！");
      self.$coreMethods.confirm(
        function () {
          let params = {
            sysUserId: self.sysUser.sysUserId,
          };
          resetPassword(params).then((res) => {
            if (res.success) self.$coreMethods.message("success", res.msg);
          });
        },
        function () {},
        false,
        "是否重置密码？"
      );
    },
    associate_queryMethod_sysDataAuthorityRangeQuery({
      keyword,
      pageSize,
      currentPage,
    }) {
      let self = this;
      let searchColumns = new URLSearchParams();
      searchColumns.append(
        "searchColumns",
        '{"propertyName":"isActive","columnName": "IS_ACTIVE","dataType": "S","value": "1","operation": "EQ"}'
      );
      searchColumns.append(
        "searchColumns",
        '{"propertyName":"isDeleted","columnName": "IS_DELETED","dataType": "S","value": "0","operation": "EQ"}'
      );
      searchColumns.append(
        "sortColumns",
        '{"propertyName":"dataAuthorityName","columnName":"DATA_AUTHORITY_NAME","sortDirection":"asc","sortOrder":"1"}'
      );
      searchColumns.append("currentPage", currentPage);
      searchColumns.append("pageSize", 10);
      searchColumns.append("queryResultType", "page");
      searchColumns.append("sum", false);
      searchColumns.append("dataAuthorityName", keyword);
      keyword
        ? searchColumns.append(
            "searchColumns",
            '{"propertyName":"dataAuthorityName","columnName": "DATA_AUTHORITY_NAME","dataType": "S","value": ' +
              keyword +
              ',"operation": "LIKEIC"}'
          )
        : void 0;
      return new Promise((resolve) => {
        sysDataAuthorityRangeQuery(searchColumns).then((res) => {
          console.log("res", res);
          resolve({
            records: res.sysDataAuthoritys,
            total: parseInt(res.total),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    querySysUserRole(sysUserId) {
      let self = this;
      let searchColumns = new URLSearchParams();
      searchColumns.append("sum", false);
      searchColumns.append("queryResultType", "list");
      searchColumns.append(
        "searchColumns",
        '{"propertyName":"sysUserId","columnName": "SYS_USER_ID","dataType": "S","value": ' +
          sysUserId +
          ',"operation": "EQ"}'
      );
      return querySysUserRole(searchColumns).then((res) => {
        let { sysUserRoles } = res;
        self.$set(self.sysUser, "sysUserRoles", sysUserRoles);
        self.sysUser.dataAuthorityName ? self.sysUser.dataAuthorityNames = self.sysUser.dataAuthorityName.split(';') : self.sysUser.dataAuthorityNames = []
        console.log(self.$refs.userManagementTableRef);
      });
    },
    associate_queryMethod_sysCorp({
      keyword,
      pageSize,
      currentPage,
    }) {
      let self = this;
      if(this.filterOfficeIds!=undefined && this.filterOfficeIds.length == 0){
        self.$coreMethods.message("failure","请勾选业务组织");
        return;
      }
      let searchColumns = new URLSearchParams();
      searchColumns.append("currentPage", currentPage);
      searchColumns.append("pageSize", 10);
        searchColumns.append(
        "searchColumns",
        '{"propertyName":"isActive","columnName": "IS_ACTIVE","dataType": "S","value": "1","operation": "EQ"}'
      );
       searchColumns.append("pageSize", 10);
        searchColumns.append(
        "searchColumns",
        '{"propertyName":"isDeleted","columnName": "IS_DELETED","dataType": "S","value": "0","operation": "EQ"}'
      );
        searchColumns.append(
        "sortColumns",
        '{"propertyName":"corpNameCn","columnName": "CORP_NAME_CN","sortDirection":"asc","sortOrder":"1"}'
      );
          searchColumns.append(
        "queryResultType",
        'page'
      );
       searchColumns.append(
        "sum",
        false
      );
        searchColumns.append(
        "filterOfficeIds",
        this.filterOfficeIds
      );
      searchColumns.append(
        "corpName",
        keyword
      );
       if (keyword) {
        searchColumns.append(
          "searchColumns",
          '{"propertyName":"corpCode","columnName": "CORP_CODE","dataType": "S","junction":"or","value": ' +
            keyword +
            ',"operation": "LIKEIC"}'
        );
        searchColumns.append(
          "searchColumns",
          '{"propertyName":"corpName","columnName": "CORP_NAME","dataType": "S","junction":"or","value": ' +
            keyword +
            ',"operation": "LIKEIC"}'
        );
         searchColumns.append(
          "searchColumns",
          '{"propertyName":"corpNameCn","columnName": "CORP_NAME_CN","dataType": "S","junction":"or","value": ' +
            keyword +
            ',"operation": "LIKEIC"}'
        );
      }
      return new Promise((resolve) => {
        settleByOfficeIds(searchColumns).then((res) => {
          console.log("res", res);
          resolve({
            records: res.sysCorp,
            total: parseInt(res.total),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    associate_queryMethod_OfficeName({
      keyword,
      pageSize,
      currentPage,
    }) {
let self = this;
      if(this.filterOfficeIds!=undefined && this.filterOfficeIds.length == 0){
        self.$coreMethods.message("failure","请勾选业务组织");
        return;
      }
      let searchColumns = new URLSearchParams();
      searchColumns.append("currentPage", currentPage);
      searchColumns.append("pageSize", 10);
        searchColumns.append(
        "searchColumns",
        '{"propertyName":"isActive","columnName": "IS_ACTIVE","dataType": "S","value": "1","operation": "EQ"}'
      );
      searchColumns.append(
        "queryResultType",
        'page'
      );
       searchColumns.append(
        "sum",
        false
      );
       searchColumns.append(
        "sortColumns",
        '{"propertyName":"parentOfficeName","columnName": "PARENT_OFFICE_NAME","sortDirection":"asc","sortOrder":"1"}'
      );
      searchColumns.append("pageSize", 10);
        searchColumns.append(
        "filterOfficeIds",
        this.filterOfficeIds
      );
      searchColumns.append(
        "officeName",
        keyword
      );
       if (keyword) {
        searchColumns.append(
          "searchColumns",
          '{"propertyName":"officeName","columnName": "OFFICE_NAME","dataType": "S","junction":"or","value": ' +
            keyword +
            ',"operation": "LIKEIC"}'
        );
        searchColumns.append(
          "searchColumns",
          '{"propertyName":"officeCode","columnName": "OFFICE_CODE","dataType": "S","junction":"or","value": ' +
            keyword +
            ',"operation": "LIKEIC"}'
        );
      }
       return new Promise((resolve) => {
        sysOffice(searchColumns).then((res) => {
          console.log("res", res);
          resolve({
            records: res.sysOffices,
            total: parseInt(res.total),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    associate_queryMethod_roleNameSysUserRole({
      keyword,
      pageSize,
      currentPage,
    }) {
      let self = this;
      let searchColumns = new URLSearchParams();
      searchColumns.append("currentPage", currentPage);
      searchColumns.append("pageSize", 10);
      searchColumns.append(
        "searchColumns",
        '{"propertyName":"isDeleted","columnName": "IS_DELETED","dataType": "S","value": "0","operation": "EQ"}'
      );
      searchColumns.append(
        "sortColumns",
        '{"propertyName":"roleCode","columnName": "ROLE_CODE","sortDirection":"asc","sortOrder":"1"}'
      );
      searchColumns.append("queryResultType", "page");
      searchColumns.append("sum", false);
      searchColumns.append("roleName", keyword);
      if (keyword) {
        searchColumns.append(
          "searchColumns",
          '{"propertyName":"roleName","columnName": "ROLE_NAME","dataType": "S","junction":"or","value": ' +
            keyword +
            ',"operation": "LIKEIC"}'
        );
        searchColumns.append(
          "searchColumns",
          '{"propertyName":"roleCode","columnName": "ROLE_CODE","dataType": "S","junction":"or","value": ' +
            keyword +
            ',"operation": "LIKEIC"}'
        );
      }
      if (self.sysUser.sysUserRoles.length > 0) {
        let value = "";
        self.sysUser.sysUserRoles.forEach((item) => {
          value += item.sysRoleId;
        });
        searchColumns.append(
          "searchColumns",
          '{"propertyName":"sysRoleId","columnName": "SYS_ROLE_ID","dataType": "S","junction":"or","value": ' +
            value +
            ',"operation":"NIN"}'
        );
      }
      return new Promise((resolve) => {
        querySysRole(searchColumns).then((res) => {
          console.log("res", res);
          resolve({
            records: res.sysRoles,
            total: parseInt(res.total),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    handleClick() {
    },
    loadNode(node, resolve) {
      if (node.level === 0) {
        return resolve([{ name: "华贸股份" }]);
      }
      if (node.level > 1) return resolve([]);

      setTimeout(() => {
        const data = [
          {
            name: "leaf",
            leaf: true,
          },
          {
            name: "zone",
          },
        ];

        resolve(data);
      }, 500);
    },
    changeRoleNameSysUserRole(value, selectedRows) {
      this.currentRoleNameSysUserRole.sysRoleId = selectedRows.sysRoleId;
    },
    currentRoleNameSysUserRoleRowClick(value) {
      this.currentRoleNameSysUserRole = value.record;
    },
    // 新增
    handleAdd() {
      this.$router.push({
        name: "UserAdd",
      });
    },
    //保存
    preserve() {
      let self = this;
      // self.sysUser.rowStatus=8

      self.$refs.ruleFormRef.validate((flag) => {
        if(flag){
          self.sysUser.userType = self.sysUser.userTypeCn.join(",");
          if (self.type === "save") return self.save();
          self.sysUser.rowStatus = 16;
          self.sysUser.dataAuthorityIds = 16;
          update(self.sysUser).then(async (res) => {
            self.getData(self.sysUser.sysUserId);
            self.$coreMethods.message("success", "保存成功");
          });
        }else{
          self.$coreMethods.message("failure","请输入必填项")
        }
      })


    },
    //新增保存
    save() {
        let self = this;
            var userName= self.sysUser.userName;
            let data = {
              userName:userName
            }
        checkSysUserName(data).then((res) => {
                  if (res.success) {
                   var u=document.getElementById("userName");
                       if(res.result){
                         u.style.borderColor="#F56C6C";
                        self.$coreMethods.message('error', '该登录账号已存在,无法保存！')
                       }else{
                         u.style.borderColor="#DCDFE6";
                          self.sysUser.filterOfficeIds = this.filterOfficeIds;
                                save(self.sysUser).then((res) => {
                                  if (res.success) {
                                    self.$coreMethods.message("success", "保存成功");
                                    self.type = "update";
                                    self.getData(res.sysUser.sysUserId);
                                  }
                                });
                       }
                   }
              });


    },
    // 启用
    handleEnable() {
      let self = this;
      if (self.sysUser.isActive === 1)
        return self.$coreMethods.message(
          "warning",
          "该用户已是生效用户，不可再生效"
        );
      let obj = {
        active: 1,
        sysUserIds: "",
      };
      obj.sysUserIds = self.sysUser.sysUserId;
      activeSysUser(obj).then((res) => {
        self.getData(self.sysUser.sysUserId);
        self.$coreMethods.message("warning", "生效成功");
      });
      // self.sysUser.isActive=1
    },
    // 禁用
    handleDisable() {
      let self = this;
      if (self.sysUser.isActive === 0)
        return self.$coreMethods.message(
          "warning",
          "该用户已是失效用户，不可再失效"
        );
      let obj = {
        active: 0,
        sysUserIds: "",
      };
      obj.sysUserIds = self.sysUser.sysUserId;
      activeSysUser(obj).then((res) => {
        self.getData(self.sysUser.sysUserId);
        self.$coreMethods.message("warning", "失效成功");
      });
    },
    // 查询
    handleQuery() {},
    // 重置
    handleReset() {},
    // pageSize 改变时会触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageConfig.pageSize = val;
    },
    // currentPage 改变时会触发
    handleCurrentChange(val) {
      this.pageConfig.currentPage = val;
    },
    //数据字典
    getSelectList() {
      let self = this;
      queryDictRows(
        "Sex,InserviceStatus,UserType,UserSource,MD_CODE_DICT$MD_CODE_YESNO,MD_CODE_DICT$MD_USER_EXTERNAL_TYPE"
      ).then((res) => {
        console.log(res);
        self.userTypelist = res.UserType;
        self.inserviceStatus = res.InserviceStatus;
        self.sex = res.Sex;
        self.userSource = res.UserSource;
        self.isActiveList = res.MD_CODE_DICT$MD_CODE_YESNO;
      });
    },
    addUesr() {
      let self = this;
      self.$refs.userManagementTableRef.hotInstance.validateColumns(
        [1],
        (userManagementTableValidate) => {
          if (userManagementTableValidate) {
            let addUesrObj = {
              isDeleted: "0",
              roleName: "",
              sysRoleId: "",
              rowStatus: 4,
              userName: self.sysUser.userNameCn,
            };
            this.sysUser.sysUserRoles.push(addUesrObj);
          }
        }
      );
    },
    deleteUser() {
      let self = this;
      const selections = this.$refs.userManagementTableRef.getSelections();
      let deleteList = [];
      let indexList = [];
      let sysUserRoles = this.sysUser.sysUserRoles;
      if (selections && selections.length > 0) {
        selections.forEach((selection) => {
          if (selection.sysRoleUserId) {
            deleteList.push(selection);
          }
          const index = sysUserRoles.indexOf(selection);
          indexList.push(index);
        });
      } else {
        this.$coreMethods.message("warning", "请勾选一条记录");
      }
      if (deleteList && deleteList.length > 0) {
        let deleteQuery = [];
        deleteList.forEach((item) => {
          deleteQuery.push(item.sysRoleUserId);
        });
        let deleteParams = {
          sysUserId: self.sysUser.sysUserId,
        };
        deletesSysUserRole(deleteQuery, deleteParams).then((res) => {
          if (res.success) {
            self.$coreMethods.message("success", "删除成功！");
            selections.forEach((item) => {
              let index = self.sysUser.sysUserRoles.indexOf(item);
              self.sysUser.sysUserRoles.splice(index, 1);
            });
          }
        });
      } else {
        let offset = 0;
        indexList.forEach((index) => {
          sysUserRoles.splice(index - offset, 1);
          offset++;
        });
      }
    },
    addExternalCode() {
      let self = this;
      let addExternalCodeObj = {
        externalCodeType: "",
        externalCode: "",
        externalCodeName: "",
        userGroup: "",
        founder: "",
        creationTime: "",
        lastModifier: "",
        modificationDate: "",
      };
      this.externalCodeRequests.push(addExternalCodeObj);
    },
    deleteExternalCode() {
      const selections = this.$refs.externalcodeMaintenance.getSelections();
      let deleteList = [];
      let indexList = [];
      let externalCodeRequests = this.externalCodeRequests;
      if (selections && selections.length > 0) {
        selections.forEach((selection) => {
          if (selection.externalCodeRequestsId) {
            deleteList.push(selection.externalCodeId);
          }
          const index = externalCodeRequests.indexOf(selection);
          indexList.push(index);
        });
      } else {
        this.$coreMethods.message("warning", "请勾选一条记录");
      }
      if (deleteList && deleteList.length > 0) {
      } else {
        let offset = 0;
        indexList.forEach((index) => {
          externalCodeRequests.splice(index - offset, 1);
          offset++;
        });
      }
    },
    handleNodeClick(treeData) {
      console.log(treeData);
    },
    changeOfficeTree(checkedNodes,checkedNodesList) {
      let filterOfficeIds = ''
      checkedNodesList.checkedNodes.forEach(item => {
        filterOfficeIds += (item.id + ',')
      })
      this.filterOfficeIds = filterOfficeIds
    },
  },
};
</script>

<style scoped lang="less">
</style>
